import { AssetGroup } from "src/modules/Asset-group/models";
import { Asset } from "src/modules/Asset/models";

export class Booking {
  name: string;

  billNo: string;

  reference: string;

  mobile: string;

  alternativeMobile: string;

  deliveryDate: string;

  returnDate: string;

  isSameDateDelivery: boolean;

  paymentMethod: string;

  rent: string;

  advance: string;

  depositeStatus: string;

  remark: string;

  depositeAmount: string;

  bookingStatus: string;

  address: string;

  bookingAssets: BookingAsset[];

  id: number;

  tenantId: string;
  
  bookingDate: Date;
}

export class BookingAsset
 {
  id: number;
  
  booking: Booking
  
  assetGroup: AssetGroup;
  
  asset: Asset;
  
  deliveryDate: any;
  
  returnDate: any;
  
  bookingStatus: Status;

  groupId: number;
}

export enum Status {
  BOOKED = 'BOOKED',
  DELIVERED = 'DELIVERED',
  RECEIVED = 'RECEIVED',
  CANCELLED = 'CANCELLED',
}

export enum DepositeStatus {
  RECEIVE = 'RECEIVE',
  PENDING = 'PENDING',
  RETURN = 'RETURN'
}
